<template>
  <el-drawer
  :title="$t('CMSProduct.add_new_release_year_title')"
  :visible.sync="visible"
  :direction="direction"
  :append-to-body="true"
  :before-close="close"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight"   v-loading="fullScreenLoading">
    <el-form label-width="200px" ref="form" :model="model" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Information générale" name="1">
          <el-row>
            <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="6" class="text-center">
              <ImageUploadWidget v-if="model.image==null && productGaleryType!=null" :typeId="productGaleryType.id" @select="v => handleGalerySelection(v, 'image')"></ImageUploadWidget>
              <div class="item card-base card-alt text-center" v-if="model.image!=null">
                <img v-lazy="model.image.link" style="height:300px;"/>
              </div>
              <span v-if="model.image!=null"><el-button type="text" @click="removeLogo">{{$t('CMSProduct.logo.remove')}}</el-button></span>
            </el-col>
            <el-col :xs="16" :sm="18" :md="18" :lg="18" :xl="18">
              <el-row>
                <el-col>
                  <el-form-item :label="$t('CMSProduct.Product')">
                    <el-input :value="getProductName(erpProduct)" :readonly="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item :label="$t('CMSProduct.releaseYear')" prop="releaseYear">
                    <el-input v-model="model.releaseYear"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col>
                  <el-form-item :label="$t('CMSProduct.inventory')" prop="inventory">
                    <el-select v-model="model.inventory" placeholder="Selectionner" value-key="id" @change="handleInventoryChange">
                       <el-option
                         v-for="item in inventories"
                         :key="item.id"
                         :label="item.name"
                         :value="item">
                       </el-option>
                     </el-select>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col>
                  <el-form-item :label="$t('CMSProduct.erpItems')">
                    <el-select v-model="model.erpItems" placeholder="Selectionner" value-key="id" multiple>
                       <el-option
                         v-for="item in erpItemsOptions"
                         :key="item.id"
                         :label="item.reference"
                         :disabled="item.fk_cms_product_item_id!=null && item.fk_cms_product_item_id!=productItemId"
                         :value="item">
                       </el-option>
                     </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col>
                  <el-form-item :label="$t('CMSProduct.web_site')">
                    <el-input placeholder="Saisir une adresse web" v-model="model.webSite">
                      <template slot="prepend">Http://</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Fiche technique" name="2">
          <el-tabs v-model="languageName">
            <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                <el-form-item v-for="i in model.properties" :key="i.label.id" :label="i.label.label[l.code]">
                  <el-input v-model="i.value.value[l.code]"></el-input>
                </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="dialog-footer card-shadow--large">
      <el-button @click="close">Annuler</el-button>
      <el-button @click="save">Enregistrer</el-button>
    </div>
</div>
</el-drawer>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import itemsAPI from '@/services/API/items'
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '@/core/event-bus'
import productUtil from '@/utils/product-util'
import ImageUploadWidget from "./image-upload-widget"

export default {
  name: 'cms-product-item-drawer',
	props: {
		visible : Boolean,
    productTypeId : Number,
    productId : Number,
    erpProduct : Object,
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    },
    productItemId : Number,
    duplicateProductItemId : Number,
    galeryTypes: {
      type: Array,
      detault: () => [],
    }
	},
  data() {
    return {
      activeNames : ['1','2'],
      fullScreenLoading : false,
      languageName : 'fr',
      template : [],
      erpItemsOptions : [],
      model : {
        releaseYear : null,
        properties : [],
        lockVersion : null,
        // inventory : null,
        // erpItems : [],
        webSite : null,
        image : null,
      },
      window: {
        width: 0,
        height: 0
      },
      // galeryTypes : [],
      rules : {
        // releaseYear : [
        //   { required: true, message: 'Veuillez saisir un millésime', trigger: 'blur' }
        // ],
        // inventory : [
        //   { required: true, message: 'Veuillez sélectionner un inventaire', trigger: 'blur' }
        // ]
      }
    };
  },components: {
    ImageUploadWidget
  },
	methods: {
    removeLogo(){
      this.model.image = null;
    },
    handleGalerySelection(asset, usedFor){
      if(usedFor=='image'){
        this.model.image = asset[0];
      }
    },
    initProperties(productItem){
      this.model.properties.splice(0);
      if(!this.editionMode){
        _.forEach(productItem, t=>{
          let prop = {};
          prop.label = {id : t.id};
          prop.label.label = {};
          prop.value = {value : {}};
          _.forIn(t.label, (l, key)=>{
            prop.label.label[key] = l;
            prop.value.value[key]=""
          })
          this.model.properties.push(prop);
        })
      }else{
        this.model.id = this.duplicateProductItemId == null ?  productItem.id : null;
        this.model.releaseYear = productItem.releaseYear;
        this.model.properties = productItem.properties;
        this.model.lockVersion = productItem.lockVersion;
        // this.model.inventory = productItem.inventory;
        // this.model.erpItems = productItem.erpItems;
        this.model.webSite = productItem.webSite;
        this.model.image = productItem.image;
      }

    },
    getProductTemplate(productTypeId){
      this.templateLoading = true;
      return cmsAPI.getProductItemPropertyLabels(productTypeId)
        .then(template=>{
          this.template = template;
          return template;
        })

    },
    resetFields(){
      this.model.releaseYear = null,
      // this.model.inventory = null;
      // this.model.erpItems.splice(0);
      this.model.webSite = null;
      this.model.image = null;
      this.fullScreenLoading = false;
      this.languageName = 'fr';
    },
    getProductItem(productItemId, lang){
      return cmsAPI.getCMSProductItem(productItemId)
    },
    initialize(){
      if(!this.editionMode){
        return this.getProductTemplate(this.productTypeId)
      }else{
        const productItemId = this.productItemId != null ? this.productItemId : this.duplicateProductItemId
        return this.getProductItem(productItemId, this.lang)
          // .then(productItem=>{
          //   return this.fetchErpItems(this.erpProduct.id, productItem.inventory.id)
          //     .then(()=>productItem)
          // })
      }
    },
    open(){
      this.fullScreenLoading = true;
      this.initialize()
        .then(initObj=>this.initProperties(initObj))
        .then(()=>{this.fullScreenLoading=false;})
    },
    buildPostData(){
      let postData = {};
      postData.releaseYear = this.model.releaseYear;
      // postData.erpItems = this.model.erpItems;
      postData.product = {id : this.productId };
      // postData.inventory = this.model.inventory != null ? {id:this.model.inventory.id} : undefined;
      postData.properties = this.model.properties;
      postData.webSite = this.model.webSite;
      postData.image = this.model.image;
      postData.lockVersion = this.model.lockVersion!=null ? this.model.lockVersion : undefined;
      return postData;
    },
    saveProductItem(){
      this.fullScreenLoading = true;

      return cmsAPI.saveCMSProductItem(this.buildPostData())
        .then(productItemCreated=>{
          this.$message.success(this.$i18n.t('CMSProduct.product_item_created'));
          this.fullScreenLoading = false;
          this.$emit('add',productItemCreated);
          this.close();
        }).catch(err=>{
          console.log(err);
          this.fullScreenLoading = false;
          this.$message.error(this.$i18n.t('CMSProduct.product_item_creation_failed'));
        })

    },
    updateProductItem(){
      this.fullScreenLoading = true;

      return cmsAPI.updateCMSProductItem(this.model.id, this.buildPostData())
        .then(productItemUpdated=>{
          this.$message.success(this.$i18n.t('CMSProduct.product_item_updated'));
          this.fullScreenLoading = false;
          this.$emit('update',this.model.id);
          EventBus.$emit('product-item-updated', this.model.id);
          this.close();
        }).catch(err=>{
          console.log(err);
          this.fullScreenLoading = false;
          this.$message.error(this.$i18n.t('CMSProduct.product_item_update_failed'));
        })

    },
    validateForm(){
      return this.$refs['form'].validate()
        .then(valid=>{
          if(valid) return true;
          else return Promise.reject(false);
        })
    },
    save(){
      this.validateForm()
        .then(()=>{
          if(!this.editionMode || this.duplicateProductItemId != null){
            this.saveProductItem()
          }else{
            this.updateProductItem();
          }
        })

    },
    close(){
      this.$emit('close');
      this.resetFields();

    },
    // handleInventoryChange(inventory){
    //   if(this.model.erpItems.length>0){
    //     this.$confirm(this.$i18n.t('CMSProduct.inventory_change_confirmation_msg'), 'Warning', {
    //       confirmButtonText: 'OK',
    //       cancelButtonText: 'Annuler',
    //       type: 'warning'
    //     }).then(()=>this.fetchErpItems(this.erpProduct.id, inventory.id))
    //     .catch(err=>{
    //       /*do nothing*/
    //     })
    //   }else{
    //     this.fetchErpItems(this.erpProduct.id, inventory.id)
    //   }
    // },
    // fetchErpItems(productId, inventoryId){
    //   return itemsAPI.listItems({productId, inventoryId})
    //     .then(erpItems=>{
    //       this.erpItemsOptions = erpItems;
    //     }).catch(err=>{
    //       console.log(err);
    //       this.$message.error(this.$i18n.t('CMSProduct.error_fetch_erpItems'));
    //     })
    // },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getProductName(erpProduct){
      return productUtil.productName(erpProduct);
    },
    // fetchCMSGalleryTypes(){
    //   return cmsAPI.fetchCMSGalleryTypes()
    //     .then(types=>{
    //       this.galeryTypes.push(...types);
    //     })
    // },
    ...mapActions('controlData',['fetchLanguages']),
    ...mapActions('inventory', ['fetchInventories'])
	},
	computed: {
    productGaleryType(){
      return _.find(this.galeryTypes, t=>{return t.code=='PRODUCT'})
    },
    editionMode(){
      return this.productItemId!=null;
    },
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    divHeight(){
      return "height :"+ (this.window.height-140) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "70%";
      }else{
        return "100%"
      }
    },
    ...mapState('controlData',['languages']),
    ...mapState('inventory',['inventories'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    return Promise.all([
      this.fetchLanguages(),
      this.fetchInventories(),
      // this.fetchCMSGalleryTypes(),
    ])
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
